export const REAL_ENDPOINTS_LIST = [
  'search',
  'searchSuggestions',
  'getCategoriesOrder',
  'getAllCategories',
];
